import { ExpressionResolverFn } from "../core/types";

import { createCachedResolver } from "./cache/cachedResolver";
import { differentThan } from "./resolvers/differentThan";
import { hasPermissionResolver } from "./resolvers/hasPermission";
import { isEmptyResolver } from "./resolvers/isEmpty";
import { nonSystemicResolver } from "./resolvers/nonSystemic";
import { regexValidator } from "./resolvers/regex";

interface ResolverRegistration {
  resolver: ExpressionResolverFn;
  cache?: {
    ttl: number;
    enabled: boolean;
  };
}

const expressionsMap = new Map<string, ResolverRegistration>();
const cachedResolvers = new Map<string, ExpressionResolverFn>();

// Register resolvers with optional caching configuration
expressionsMap.set("regex", { resolver: regexValidator });
expressionsMap.set("different-than", { resolver: differentThan });
expressionsMap.set("has-permission", {
  resolver: hasPermissionResolver,
  cache: { ttl: 5 * 60_000, enabled: true }, // 5 minutes
});
expressionsMap.set("is-empty", { resolver: isEmptyResolver });
expressionsMap.set("non-systemic", { resolver: nonSystemicResolver });

export const getExpressionResolver = (
  type: string
): ExpressionResolverFn | undefined => {
  const registration = expressionsMap.get(type);
  if (!registration) {
    return undefined;
  }

  const { resolver, cache } = registration;

  if (cache?.enabled) {
    let cachedResolver = cachedResolvers.get(type);
    if (!cachedResolver) {
      cachedResolver = createCachedResolver(resolver, cache.ttl);
      cachedResolvers.set(type, cachedResolver);
    }
    return cachedResolver;
  }

  return resolver;
};
